import { CHECK_AUTH_REQUEST, LOGIN_REQUEST, LOGOUT_REQUEST, UPDATE_USER_INFO, } from './actionTypes';
export var loginRequest = function (payload) { return ({
    type: LOGIN_REQUEST,
    payload: payload,
}); };
export var logoutRequest = function () { return ({
    type: LOGOUT_REQUEST,
}); };
export var checkAuthRequest = function () { return ({
    type: CHECK_AUTH_REQUEST,
}); };
export var updateUserInfoRequest = function (payload) { return ({
    type: UPDATE_USER_INFO,
    payload: payload,
}); };
